 
  export interface IPartitionData {
    position: string;
    name: string;
  }
  
  export interface IPartitionsViewData {
    instrumentId: string;
    instrumentName: string;
    variable: string;
    partitions: IPartitionData[];
  }
  
  export default class PartitionsViewData implements IPartitionsViewData {
    instrumentId: string;
    instrumentName: string;
    variable: string;
    partitions: IPartitionData[];
  
    constructor(instrumentId: string, instrumentName: string, variable: string, partitions: IPartitionData[]) {
      this.instrumentId = instrumentId;
      this.instrumentName = instrumentName;
      this.variable = variable;
      this.partitions = partitions;
    }
} 
  
  const defaultPartitionsViewData = new PartitionsViewData("", "", "", []);
  export { defaultPartitionsViewData };
  